import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Chip, TableSortLabel, Tooltip, Typography } from "@mui/material";
import { Box } from "@mui/system";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import SimpleBackdrop from "../../../../BackDrop/BackDrop";

const reviewTableHeadings = {
  finance_company_name: "Company",
  receipt_date: "Date",
  receipt_id: "Receipt Number",
  receipt_amount: "Receipt Amount",
  receipt_status: "Receipt Status",
  fme: "FME",
};

const FmeUnpairFinalModalTable = ({ isUnpairing }: any) => {
  const headCells = Object.entries(reviewTableHeadings);
  const { unpairPreviewReceipt } = useSelector((state: any) => state.receipts);

  const rows = unpairPreviewReceipt ? [unpairPreviewReceipt] : [];

  return (
    <>
      {isUnpairing && <SimpleBackdrop />}
      <Typography>Preview:</Typography>
      <TableContainer
        className="receiptsTable EditReceiptsLinkedFmeTable"
        sx={{ mb: 3, mt: 1 }}
      >
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              {headCells.map(([_, value], index) => (
                <TableCell key={index} align="left">
                  <TableSortLabel>
                    {value && typeof value === "string" ? value : ""}
                  </TableSortLabel>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows?.map((row: any) => {
              return (
                <React.Fragment key={row.cron_id}>
                  <TableRow
                    sx={{
                      "& > *": {
                        borderBottom:
                          "1px solid rgba(224, 224, 224, 1) !important",
                      },
                    }}
                  >
                    {headCells.map(([key], cellIndex) => (
                      <TableCell key={cellIndex} align="left">
                        {key === "finance_company_name" ? (
                          <>{row[key] ? row[key] : "N/A"} </>
                        ) : key === "receipt_date" ? (
                          <>
                            {row[key]
                              ? dayjs(row[key]).format("DD/MM/YYYY")
                              : "N/A"}
                          </>
                        ) : key === "receipt_id" ? (
                          <>{row[key] ? row[key] : "N/A"} </>
                        ) : key === "receipt_amount" ? (
                          <>
                            <Box display={"flex"} alignItems={"center"}>
                              {row[key] ? row[key] : "N/A"}{" "}
                              <span style={{ marginLeft: 6, opacity: 0.7 }}>
                                {row.receipt_currency_symbol}
                              </span>
                            </Box>
                          </>
                        ) : key === "receipt_status" ? (
                          <>
                            <div className="AlertItems">
                              {row[key] ? row[key] : "N/A"}
                            </div>
                          </>
                        ) : key === "fme" ? (
                          <div className="chip-data">
                            <Box
                              sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}
                            >
                              {/* First FME only */}
                              {row.fmes.length > 0 && (
                                <Chip
                                  label={row.fmes[0].fme_id}
                                  sx={{
                                    backgroundColor: "#ffffff",
                                    color: "rgba(0, 0, 0, 0.87)",
                                    borderRadius: "5px",
                                    boxShadow: "1px 1px 2px 1px #00000030",
                                    height: "26px",
                                    fontWeight: "500",
                                    border: "1px solid #ffffff",
                                  }}
                                />
                              )}

                              {/* Tooltip for remaining FMEs */}
                              {row.fmes.length > 1 && (
                                <Tooltip
                                  title={row.fmes
                                    .map((f: any) => f.fme_id)
                                    .join(", ")}
                                  arrow
                                >
                                  <Chip
                                    label={`+${row.fmes.length - 1}`}
                                    sx={{
                                      backgroundColor: "#f0f0f0",
                                      cursor: "pointer",
                                      height: "26px",
                                    }}
                                  />
                                </Tooltip>
                              )}
                            </Box>
                          </div>
                        ) : (
                          "N/A"
                        )}
                      </TableCell>
                    ))}
                  </TableRow>
                </React.Fragment>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default FmeUnpairFinalModalTable;
